export type SimpleEventUnsubscriber = () => void
export class SimpleEventDispatcher<T extends Record<string | number | symbol, any>> {
    private subscribers: Record<keyof T, Array<(payload: T[keyof T]) => void>>

    constructor() {
        this.subscribers = {} as Record<keyof T, Array<(payload: T[keyof T]) => void>>
    }

    subscribe<K extends keyof T>(eventName: K, callback: (payload: T[K]) => void): SimpleEventUnsubscriber {
        if (!this.subscribers[eventName]) {
            this.subscribers[eventName] = []
        }

        // Don't have time for this sh*te
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.subscribers[eventName].push(callback)
        return () => {
            const index = this.subscribers[eventName].findIndex(storedCallback => storedCallback === callback)
            this.subscribers[eventName] = this.subscribers[eventName].splice(index, 1)
        }
    }

    dispatch<K extends keyof T>(name: K, payload?: T[K]): void {
        const subscribers = this.subscribers[name]

        if (!subscribers) {
            return
        }

        for (const callback of subscribers) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            callback(payload)
        }
    }
}
